import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import EMPDashboard from "./components/Employee/EMPDashboard";
import Sidebar from "./components/Sidebar";

import LeaveHistory from "./components/Employee/LeaveHistory";
import LeaveDetails from "./components/Employee/LeaveDetails";
import LeaveOverview from "./components/Employee/LeaveOverview";
import DailyLogs from "./components/Employee/DailyLogs";
import CompanyPolicies from "./components/Employee/CompanyPolicies";
import HRDashboard from "./components/HR/HRDashboard";

import LeaveRequest from "./components/HR/LeaveRequest";
import LeaveDetailsHR from "./components/HR/LeaveDetails";
import Employees from "./components/HR/Employees";
import EmpLeaveHistory from "./components/HR/EmpLeaveHistory";
import CompanyHierarchy from "./components/HR/CompanyHierarchy";
import Login from "./components/Login";
import HolidayList from "./components/Employee/HolidayList";
import LeaveConfiguration from "./components/HR/LeaveConfiguration";
import Reports from "./components/HR/Reports";

import AuthService from "./services/auth.service";

import "./App.css";
import HelpDesk from "./components/common/HelpDesk";
import Grievences from "./components/common/Grievences";
import CompOff from "./components/Employee/CompOff";
import DutyDetails from "./components/Employee/DutyDetails";
import HolidayShiftDetails from "./components/Employee/HolidayShiftDetails";
import ForgotPassword from "./components/ForgotPassword";
import { useStateContext } from "./contexts/ContextProvider";

import { FloatButton } from "antd";
import { IoArrowUp } from "react-icons/io5";
import AddNewEmployee from "./components/HR/AddNewEmployee";
import LeaveReconcile from "./components/HR/LeaveReconcile";
import LeaveReconcileDetails from "./components/HR/LeaveReconcileDetails";
import DailyLogsHR from "./components/HR/DailyLogsHR";
import AdityaBirlaRetentionDashboard from "./components/HR/RetentionDashboard/AdityaBirla/hrms_retention_dashboard2";
import AshavinayakRetentionDashboard from "./components/HR/RetentionDashboard/Ashtavinayak/hrms_retention_dashboard2";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [visible, setVisible] = useState(false);

  const user = AuthService.getCurrentUser();

  const { showMenu, setShowMenu } = useStateContext();
  const location = useLocation();

  const isRetentionDashboard = location.pathname.includes(
    "retention_dashboard",
  );

  useEffect(() => {
    if (user) {
      setIsLoggedIn(true);
    }
  }, [user]);

  // console.log("user", user);

  // useEffect(() => {
  //   if (user.token) {

  //   }
  // }, [])

  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="App">
      {isLoggedIn ? (
        <>
          <div
            className="main-container"
            style={{
              padding: isRetentionDashboard ? 0 : undefined,
            }}
          >
            {!isRetentionDashboard && (
              <div
                className={
                  showMenu ? "sidebar-container active" : "sidebar-container"
                }
              >
                <Sidebar
                  isLoggedIn={isLoggedIn}
                  setIsLoggedIn={setIsLoggedIn}
                  user={user}
                />
              </div>
            )}
            <div
              className={
                isRetentionDashboard
                  ? "main-panel-bg full-width-panel"
                  : "main-panel-bg"
              }
            >
              <Routes>
                {user.role === "1" || user.role === "4" ? (
                  <>
                    <Route
                      exact
                      path="/leaveDetails"
                      element={<LeaveDetails user={user} />}
                    />
                    <Route
                      exact
                      path="/"
                      element={<HRDashboard user={user} />}
                    />

                    <Route
                      exact
                      path="/dashboard"
                      element={<HRDashboard user={user} />}
                    />
                    <Route
                      exact
                      path="/aditya_birla_retention_dashboard"
                      element={<AdityaBirlaRetentionDashboard />}
                    />
                    <Route
                      exact
                      path="/ashtavinayak_retention_dashboard"
                      element={<AshavinayakRetentionDashboard />}
                    />
                    <Route
                      exact
                      path="/leaveHistory"
                      element={<LeaveHistory user={user} />}
                    />
                    <Route
                      exact
                      path="/leaveRequest"
                      element={<LeaveRequest user={user} />}
                    />

                    <Route
                      exact
                      path="/leaveReconcile"
                      element={<LeaveReconcile user={user} />}
                    />

                    <Route
                      exact
                      path="/leaveOverview"
                      element={<LeaveOverview user={user} />}
                    />

                    <Route
                      exact
                      path="/employees"
                      element={<Employees user={user} />}
                    />

                    <Route
                      exact
                      path="/addemployee"
                      element={<AddNewEmployee user={user} />}
                    />

                    <Route
                      exact
                      path="/empLeaveHistory"
                      element={<EmpLeaveHistory user={user} />}
                    />
                    <Route
                      exact
                      path="/leaveConfiguration"
                      element={<LeaveConfiguration user={user} />}
                    />
                    <Route
                      exact
                      path="/reports"
                      element={<Reports user={user} />}
                    />

                    <Route
                      exact
                      path="/helpDesk"
                      element={<HelpDesk user={user} />}
                    />
                    <Route
                      exact
                      path="/grievances"
                      element={<Grievences user={user} />}
                    />
                    <Route
                      exact
                      path="/empLeaveDetails"
                      element={<LeaveDetails user={user} />}
                    />

                    <Route
                      exact
                      path="/leaveReconcileDetails"
                      element={<LeaveReconcileDetails user={user} />}
                    />

                    <Route
                      exact
                      path="/dailyLogs"
                      element={<DailyLogsHR user={user} />}
                    />
                  </>
                ) : user.role === "2" || user.role === "3" ? (
                  <>
                    <Route
                      exact
                      path="/empLeaveHistory"
                      element={<EmpLeaveHistory user={user} />}
                    />
                    <Route
                      exact
                      path="/empLeaveDetails"
                      element={<LeaveDetails user={user} />}
                    />
                    <Route
                      exact
                      path="/"
                      element={<EMPDashboard user={user} />}
                    />
                    <Route
                      exact
                      path="/dashboard"
                      element={<EMPDashboard user={user} />}
                    />
                    <Route
                      exact
                      path="/leaveHistory"
                      element={<LeaveHistory user={user} />}
                    />
                    <Route
                      exact
                      path="/leaveDetails"
                      element={<LeaveDetails user={user} />}
                    />

                    <Route
                      exact
                      path="/leaveOverview"
                      element={<LeaveOverview user={user} />}
                    />
                    <Route
                      exact
                      path="/helpDesk"
                      element={<HelpDesk user={user} />}
                    />
                    <Route
                      exact
                      path="/grievances"
                      element={<Grievences user={user} />}
                    />

                    <Route
                      exact
                      path="/dailyLogs"
                      element={<DailyLogs user={user} />}
                    />

                    {user.designation === "BDM" && (
                      <>
                        <Route
                          exact
                          path="/aditya_birla_retention_dashboard"
                          element={<AdityaBirlaRetentionDashboard />}
                        />
                        <Route
                          exact
                          path="/ashtavinayak_retention_dashboard"
                          element={<AshavinayakRetentionDashboard />}
                        />
                      </>
                    )}
                  </>
                ) : (
                  <></>
                )}

                <Route
                  exact
                  path="/holidayShift"
                  element={<CompOff user={user} />}
                />

                <Route
                  exact
                  path="/HolidayShiftDetails"
                  element={<HolidayShiftDetails user={user} />}
                />

                <Route
                  exact
                  path="/companyPolicies"
                  element={<CompanyPolicies user={user} />}
                />
                <Route
                  exact
                  path="/holidayList"
                  element={<HolidayList user={user} />}
                />

                {user.role === "2" && (
                  <>
                    <Route
                      exact
                      path="/leaveRequest"
                      element={<LeaveRequest user={user} />}
                    />
                    <Route
                      exact
                      path="/team"
                      element={<Employees user={user} />}
                    />
                  </>
                )}

                {user.role === "1" || user.role === "4" ? (
                  <>
                    <Route
                      exact
                      path="/companyHierarchy"
                      element={<CompanyHierarchy user={user} />}
                    />
                  </>
                ) : null}
              </Routes>
              {visible && (
                <FloatButton
                  icon={<IoArrowUp />}
                  type="primary"
                  style={{ right: 24, bottom: 24 }}
                  onClick={scrollToTop}
                />
              )}
            </div>
          </div>
        </>
      ) : (
        <>
          <Routes>
            <Route path="*" element={<Login setIsLoggedIn={setIsLoggedIn} />} />
            <Route
              exact
              path="/login"
              element={<Login setIsLoggedIn={setIsLoggedIn} />}
            />
            <Route
              exact
              path="/forgot-password"
              element={<ForgotPassword setIsLoggedIn={setIsLoggedIn} />}
            />
            <Route
              exact
              path="/aditya_birla_retention_dashboard"
              element={<AdityaBirlaRetentionDashboard />}
            />
            <Route
              exact
              path="/ashtavinayak_retention_dashboard"
              element={<AshavinayakRetentionDashboard />}
            />
          </Routes>
        </>
      )}
    </div>
  );
}

export default App;
